import { useCallback } from 'react'
import { useAppDispatch } from '@/state'
import { SportsROActions } from '@/state/sports-ro-calculator'

import {
  GetSportsROCalculatorPayload,
  SportsROLibraryColumnProps,
  SportsROFilters,
  SportsROTransactions,
} from '@/state/sports-ro-calculator/models'
import { getSportsROCalculatorThunk } from '@/state/sports-ro-calculator/thunks'
import { TableHeadCellPropsType } from '@/state/ui/global/models'

import { exportXlsxFile, removeEmptyProp } from '@/utils'

export const useSportsROCalculatorActions = () => {
  const dispatch = useAppDispatch()

  const getAllSportsROCalculator = async (
    filters: SportsROFilters,
    headCells?: TableHeadCellPropsType<SportsROLibraryColumnProps>[],
    fileName?: string,
    getFormattedRow?: (row: SportsROTransactions) => SportsROLibraryColumnProps,
  ) => {
    const payloadFilters: GetSportsROCalculatorPayload = {
      xlsx: filters.xlsx,
      username: filters.username,
      startDate: new Date(filters.startDate).toISOString(),
      endDate: new Date(filters.endDate).toISOString(),
      restrictions: removeEmptyProp({
        line: removeEmptyProp({
          max: filters.maxLine ? Number(filters.maxLine) : null,
          min: filters.minLine ? Number(filters.minLine) : null,
        }),
        sports:
          filters.sports?.map((sport) => {
            return {
              type: 3,
              action: 1,
              validationId: sport,
            }
          }) || [],
        wagerTypes:
          filters.wagerTypes?.map((wagerType) => {
            return {
              type: 2,
              action: 1,
              validationId: wagerType,
            }
          }) || [],
        rolloverAmountCalculationType: filters.rolloverAmountCalculation,
      }),
    }

    const resultAction = await dispatch(
      getSportsROCalculatorThunk({
        ...payloadFilters,
      }),
    )

    if (
      getFormattedRow &&
      headCells &&
      getSportsROCalculatorThunk.fulfilled.match(resultAction)
    ) {
      exportXlsxFile(
        headCells,
        resultAction.payload.transactions.map((item) => getFormattedRow(item)),
        fileName,
      )
    }
  }

  const setSportsROCalculatorFilters = useCallback(
    (filters: SportsROFilters) =>
      dispatch(SportsROActions.setSportROCalculatorFiltersAction(filters)),
    [dispatch],
  )

  const cleanSportsRO = useCallback(
    () => dispatch(SportsROActions.resetSportsRO()),
    [dispatch],
  )

  return {
    getAllSportsROCalculator,
    setSportsROCalculatorFilters,
    cleanSportsRO,
  }
}
